import camelCase from 'lodash/camelCase';

import { getRequest } from './api';

export type BannerPage = 'landing' | 'lobby_sc' | 'lobby_cc' | 'lobby_animation_only';

export type Banner = {
  desktop: string;
  mobile?: string | null;
  desktopBanner: {
    imageUrl: string;
    animationUrl?: string;
    animationBackgroundUrl?: string;
  };
  mobileBanner: {
    imageUrl?: string | null;
    animationUrl?: string;
    mobileAnimationBackgroundUrl?: string;
  };
};

type BannersRecord<B> = Partial<Record<BannerPage, B | null>>;
export type BannersData = BannersRecord<Banner>;

class UiService {
  private static UTM_PARAM_NAMES = ['utm_source', 'utm_campaign', 'utm_medium', 'utm_content', 'utm_term'];

  private static getUtmParams(): Record<string, string> {
    const searchParams = new URLSearchParams(window.location.search);

    return this.UTM_PARAM_NAMES.reduce<Record<string, string>>((result, paramName) => {
      const paramValue = searchParams.get(paramName);

      if (!paramValue) {
        return result;
      }

      return {
        ...result,
        [camelCase(paramName)]: paramValue,
      };
    }, {});
  }

  public async getBanners(options?: { lang?: string; theme?: string }) {
    const utmParams = UiService.getUtmParams();

    return getRequest<{ data: { banners: BannersData } }>('/v2/ui/banners', { ...options, ...utmParams });
  }
}

export const uiService = new UiService();
